import { gql } from "@grandvisionhq/graphql";
const GET_CHECKOUT_STATE = gql`
  query GetCheckoutState($getCartId: ID!) {
    getCart(id: $getCartId) {
      cart {
        checkoutState
      }
    }
  }
`;
export {
  GET_CHECKOUT_STATE
};
//# sourceMappingURL=get-checkout-state.js.map
